import { BaseParamsDto, GeneralParamsDto, InitialPersonAdditionalData, InitialPersonValues, PolicyHolderDto, VehicleDto, VehicleIdentificationDto, VehiclePriceDto } from 'BrokerTsLib/src/dtos';
import { transformDate } from '../../utils/formatDate';

// transformace dat tak, aby s nimi umely pracovat ui komponenty

export const transformVehicleDto = (vehicle: VehicleIdentificationDto & VehicleDto & VehiclePriceDto) => {
    //vehicle.firstRegistrationDate = !!vehicle.firstRegistrationDate ? new Date(vehicle.firstRegistrationDate as any) : undefined
    vehicle.firstRegistrationDate = transformDate(vehicle.firstRegistrationDate);

    // select a radionIcon neumi s intem
    vehicle.druh = vehicle.druh?.toString() as any;
    vehicle.palivo = vehicle.palivo?.toString() as any;
    vehicle.usage = vehicle.usage?.toString() as any;

    return vehicle;
};

export const transformPolicyHolderDto = (policyHolder: PolicyHolderDto) => {
    if (policyHolder.person == null) policyHolder.person = { ...InitialPersonAdditionalData }
    if (policyHolder.owner == null) policyHolder.owner = { ...InitialPersonAdditionalData }
    if (policyHolder.holder == null) policyHolder.holder = { ...InitialPersonAdditionalData }

    return policyHolder
}

export const transformGeneralParamsDto = (generalParams: GeneralParamsDto) => {
    generalParams.insuranceStartDate = transformDate(generalParams.insuranceStartDate)

    return generalParams
}